/* src/app/core/components/router-outlet/router-outlet.component.scss */
/*# sourceMappingURL=router-outlet.component-3KZGBBT5.css.map */
